import { fo_thucdon } from '../../../models/response/dich-vu/food/fo_thucdon';
import { apiClient } from '../../apiClient';
import { BaseCRUDApi } from '../../baseCRUDApi';

export const API_FO_THUCDON_PATH = "food/thucdon";

/** Body của `POST food/thucdon/theongay` (FoThucDonItemRequest.cs) */
export interface IFoThucDonSelectRequest {
	dm_coso_id: number;
	dm_truong_id: number;
	from_date: string;
	to_date: string;
}

/** Body của `POST food/thucdon/insert-multiple` (FoThucDonInsertItemRequest.cs) */
export interface IFoThucDonInsertMultipleRequest {
	dm_coso_id: number;
	dm_truong_id: number;
	ngay_an: string;
	ca_an: number;
	fo_monan_chitiet_ids: number[];
}

/** Body + tham số route của validate-import / import */
export interface IFoThucDonImportRequest {
	fileName: string;
	sheetIndex: number;
	dm_truong_id: number;
}

class FoThucDonApi extends BaseCRUDApi<fo_thucdon> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/food/thucdon`);
	}
	SelectDetailDayByDay(request: IFoThucDonSelectRequest) {
		return apiClient.post(`${API_FO_THUCDON_PATH}/theongay`, request);
	}
	InsertMultiple(request: IFoThucDonInsertMultipleRequest) {
		return apiClient.post(`${API_FO_THUCDON_PATH}/insert-multiple`, request);
	}
	ValidateImport(request: IFoThucDonImportRequest) {
		return apiClient.put(`${API_FO_THUCDON_PATH}/validate-import/truong/${request.dm_truong_id ?? 0}`, {
			fileName: request.fileName,
			sheetIndex: request.sheetIndex,
		});
	}
	Import(request: IFoThucDonImportRequest) {
		return apiClient.put(`${API_FO_THUCDON_PATH}/import/truong/${request.dm_truong_id ?? 0}`, {
			fileName: request.fileName,
			sheetIndex: request.sheetIndex,
		});
	}
}
export const foThucDonApi = new FoThucDonApi(API_FO_THUCDON_PATH);
